import { makeStyles, createStyles } from '@material-ui/core'

const drawerWidth = 288

export const useLayoutSidebarStyles = makeStyles((theme) =>
  createStyles({
    drawer: {
      width: drawerWidth,
      flexShrink: 0
    },

    drawerPaper: {
      width: drawerWidth,
      border: 'none'
    },

    drawerHeader: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
      justifyContent: 'flex-end'
    },

    list: {
      height: '100%',
      margin: 16,
      background: '#FCFCFC'
    },

    activeLink: {
      '& *': {
        color: theme.palette.primary.main
      }
    }
  })
)
